import React, { Component } from 'react';
import BaseLayout from '../../templates/base';
import ObjectiveEditForm from '../../elements/objectives/form';
import Loading from './../../elements/loading';
import ObjectivesAdd from './../../elements/objectives/widget/objectives_add';

class ObjectiveEdit extends Component {
	render() {
		const { objectives} = this.props;
		return (
			objectives.isFetching ? <Loading/>:<ObjectiveEditForm {...this.props} />
		)
	}

	componentWillMount() {
		this.props.objectiveEdit(this.props.match.params.id);
	}
}

export default BaseLayout(ObjectiveEdit, {
	title:"Editar objetivo",
	subnav: {
		icon: 'fa-flag-checkered',
		name: 'Proigualdad',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <ObjectivesAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/objectives/edit.jsx